import { createContext } from "react";
import type { StartRouteDraft } from "./startRouteDraft";

/**
 * A start's LLM choice (F106, TR-A2-04), held by the preparation (`RunPreparation`) and shown
 * where the start form places it: the Thread's default above Start (`StartRoutes`), and each
 * agent step's own in its row (`StartStepRoute`). Both choose in the one LLM picker, judged by
 * the server's route options for this start.
 */
export interface StartRoutesValue {
  readonly projectId: string;
  readonly workflow: string;
  readonly contentVersion: string;
  /** `undefined` until the PCs are read; `null` when none of them offers a route. */
  readonly draft: StartRouteDraft | null | undefined;
  readonly onDraftChange: (draft: StartRouteDraft | null) => void;
  readonly disabled: boolean;
}

export const StartRoutesContext = createContext<StartRoutesValue | null>(null);
